// extracted by mini-css-extract-plugin
export default {"productCarousel":"_3-z"};